import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import AddPoll from "./views/AddPoll.vue";
import NoRoute from "./views/404.vue";
import Share from "./views/Share.vue";
import Poll from "./views/Poll.vue";
import Profile from "./views/Profile.vue";
import Group from "./views/Group.vue";

Vue.use(Router);

let router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/login",
      name: "login",
      component: Login
    },
    {
      path: "/add-poll",
      name: "add-poll",
      component: AddPoll
    },
    {
      path: "/edit-poll/:pollId",
      name: "edit-poll",
      component: AddPoll
    },
    {
      path: "/share/:fireId",
      name: "share",
      component: Share
    },
    {
      path: "/polls/:id",
      name: "poll",
      component: Poll
    },
    {
      path: "/group/:groupId/:pollId",
      name: "groupsingle",
      component: Group
    },
    {
      path: "/group/:groupId",
      redirect: "/group/:groupId/0"
    },
    {
      path: "/event/:groupId/:pollId",
      name: "eventsingle",
      component: Group
    },
    {
      path: "/event/:groupId/",
      name: "eventsingle",
      component: Group
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile
    },
    {
      path: "*",
      name: "404",
      component: NoRoute
    }
  ]
});
export default router;
